import React, { createContext, useContext, useMemo, useState } from 'react';

const translations = {
  es: {
    app_title: 'Panel de Integración',
    app_subtitle: 'TikTok Shop → QuickBooks Online',
    login: { title: 'Ingresar', email: 'Correo electrónico', password: 'Contraseña',
      submit: 'Ingresar', error: 'Credenciales inválidas',
      hint: 'Tip: admin@lovicreation.shop / Admin123!' },
    auth: { change_my_password: 'Cambiar mi contraseña',
      current_password: 'Contraseña actual', new_password: 'Nueva contraseña',
      confirm_password: 'Confirmar contraseña', password_mismatch: 'Las contraseñas no coinciden',
      change_password_success: 'Contraseña actualizada correctamente',
      change_password_wrong_current: 'La contraseña actual es incorrecta',
      change_password_error: 'No se pudo cambiar la contraseña',
      reset_password_title: 'Cambiar contraseña de usuario',
      reset_password_success: 'Contraseña actualizada',
      reset_password_error: 'No se pudo actualizar la contraseña' },
    nav: { dashboard: 'Inicio', orders: 'Órdenes', settlements: 'Liquidaciones',
      sales_reports: 'Reportes de ventas', // Fix 52 (2026-10-07)
      manual_review: 'Revisión manual', clearing: 'Cuenta clearing',
      logs: 'Logs', config: 'Configuración', health: 'Estado del sistema',
      integrations: 'Integraciones', depositos: 'Depósitos banco',
      duplicate_customers: 'Clientes duplicados',
      new_customers: 'Clientes nuevos',
      agenda: 'Agenda iCloud',
      logout: 'Cerrar sesión' },
    // Fix 51 (2026-10-06): acceso a la Agenda iCloud desde Integraciones.
    agenda_link: {
      title: 'Contactos de iCloud',
      text: 'La conexión, la sincronización y las listas de contactos están en la pantalla Agenda iCloud.',
      button: 'Abrir Agenda iCloud' },
    // Fix 46 (2026-10-02): pantalla de Clientes nuevos (solo lectura).
    new_customers: { title: 'Clientes nuevos',
      subtitle: 'Compradores que hicieron su primera compra en el período',
      preset_this_week: 'Esta semana', preset_last_week: 'Semana pasada',
      preset_this_month: 'Este mes', preset_last_month: 'Mes pasado',
      preset_last_30: 'Últimos 30 días', preset_this_year: 'Este año',
      from: 'Desde', to: 'Hasta',
      kpi_new: 'Clientes nuevos', kpi_repeat: 'Volvieron a comprar',
      kpi_total: 'Total comprado', kpi_existing: 'Ya existían en QuickBooks',
      definition: 'Cliente nuevo: comprador de TikTok cuya primera compra no cancelada cae en el período y que no existía antes en QuickBooks.',
      existing_note: 'Los que ya estaban en QuickBooks (compraron antes de la plataforma o con otra cuenta de TikTok) no se cuentan; están en el Excel, en la hoja "Ya existían en QuickBooks".',
      pending_note: 'con datos pendientes en Revisión Manual.',
      chart_title: 'Clientes nuevos', chart_by_day: 'por día',
      chart_by_week: 'por semana', chart_by_month: 'por mes',
      search_placeholder: 'Buscar por nombre, perfil, teléfono, ciudad o subasta',
      col_date: 'Fecha 1ª compra', col_customer: 'Cliente', col_nickname: 'Perfil TikTok',
      col_phone: 'Teléfono', col_location: 'Ciudad / Estado', col_auction: 'Subasta #',
      col_first_total: 'Total 1ª compra', col_orders: 'Compras', col_total: 'Total comprado',
      pending_name: 'Datos pendientes',
      download_excel: 'Excel', download_pdf: 'PDF',
      download_done: 'Reporte descargado', download_error: 'No se pudo descargar el reporte',
      empty: 'No hay clientes nuevos en este período.',
      invalid_range: 'La fecha "Desde" no puede ser posterior a "Hasta".',
      load_error: 'No se pudo cargar el reporte',
      showing: 'Mostrando', of: 'de', prev: 'Anterior', next: 'Siguiente' },
    dupes: {
      title: 'Clientes duplicados',
      subtitle: 'El sistema propone y explica; cada caso lo aprueba una persona. Nada se ejecuta solo.',
      counter_total: 'Grupos detectados',
      counter_system: 'Resolubles por el sistema',
      counter_manual: 'Requieren fusión manual en QuickBooks',
      counter_likely_different: 'Probablemente personas distintas',
      counter_resolved: 'Ya resueltos',
      status_pending: 'Pendientes', status_resolved: 'Resueltos',
      status_ignored: 'Ignorados', status_all: 'Todos',
      type_all: 'Todos los casos',
      type_system: 'Resoluble por el sistema',
      type_manual: 'Fusión manual en QuickBooks',
      type_likely_different: 'Probablemente personas distintas',
      search_placeholder: 'Buscar por nombre o teléfono…',
      matched_user_id: 'Coincide por cuenta de TikTok',
      matched_phone: 'Coincide por teléfono',
      matched_name_address: 'Coincide por nombre + dirección',
      in_identity_review: 'En revisión de identidad',
      role_keep: 'Se conserva', role_archive: 'Se archiva',
      role_neutral: 'Ficha independiente',
      inactive: 'Inactiva en QBO',
      transactions: 'transacciones',
      open_balance: 'Saldo abierto',
      no_phone: 'sin teléfono', no_address: 'sin dirección',
      no_user_id: 'sin cuenta de TikTok',
      blocker_has_transactions: 'tiene transacciones',
      blocker_open_balance: 'tiene saldo abierto',
      blocker_pending_payout: 'está en un payout pendiente',
      resolve: 'Resolver',
      howto_merge: 'Cómo fusionar en QuickBooks',
      not_same_person: 'No son la misma persona',
      ignore_hint: 'El grupo deja de aparecer en la lista de pendientes.',
      ignore_reason: 'Motivo (opcional)',
      confirm_title: 'Confirmar la resolución',
      confirm_apply: 'Sí, aplicar',
      keeps: 'Conserva', archives: 'Archiva',
      transactions_moved: 'Transacciones movidas',
      copy_keep_name: 'Copiar el nombre exacto',
      copied: 'Nombre copiado',
      open_in_qbo: 'Abrir en QuickBooks',
      already_merged: 'Ya la fusioné en QuickBooks',
      select_all_system: 'Seleccionar todos los resolubles',
      clear_selection: 'Limpiar selección',
      bulk_resolve: 'Resolver seleccionados ({{n}})',
      bulk_confirm_title: 'Resolución en lote',
      bulk_summary: 'Vas a resolver {{groups}} grupos: se conservan {{keep}} fichas con historial y se archivan {{archive}} fichas sin historial. No se mueve ninguna transacción.',
      bulk_done: 'Lote terminado: {{ok}} resueltos, {{fail}} fallidos',
      resolved_toast: 'Grupo resuelto: la ficha vacía quedó archivada en QuickBooks',
      merged_toast: 'Registro actualizado a la ficha que se conserva',
      ignored_toast: 'Grupo marcado como "no son la misma persona"',
      ignored_note: 'Marcado como personas distintas: no se hizo ningún cambio en QuickBooks ni en el registro.',
      resolved_note: 'Grupo ya resuelto: el registro apunta a la ficha que se conserva. No se movió ninguna transacción.',
      empty: 'No hay grupos con los filtros actuales.',
      error_generic: 'No se pudo completar la acción',
      error_qbo_not_connected: 'QuickBooks no está conectado: no se puede archivar nada.',
      error_qbo_writes_frozen: 'Las escrituras a QuickBooks están congeladas (FREEZE_QBO_WRITES).',
      error_manual_merge_required: 'Este caso tiene que fusionarse dentro de QuickBooks.',
      error_likely_different_group: 'Probablemente sean dos personas distintas: no se fusiona ni se archiva.',
      error_already_resolved: 'Este grupo ya estaba resuelto.',
      error_blocked: 'Bloqueado: la ficha tiene transacciones, saldo abierto o está en un payout pendiente.',
      error_group_not_found: 'El grupo ya no existe (se actualizó el reporte).',
      error_no_groups_selected: 'No seleccionaste ningún grupo.',
      error_job_already_running: 'Ya hay un lote en curso.',
    },
    common: { search: 'Buscar', status: 'Estado', date: 'Fecha', filter: 'Filtrar',
      clear: 'Limpiar', refresh: 'Refrescar', loading: 'Cargando…',
      empty: 'Sin resultados con los filtros actuales.',
      retry: 'Reintentar', view: 'Ver', back: 'Volver', save: 'Guardar',
      cancel: 'Cancelar', confirm: 'Confirmar', approve: 'Aprobar',
      reject: 'Rechazar', merge: 'Fusionar', forward: 'Reenviar',
      actions: 'Acciones', total: 'Total', amount: 'Monto', customer: 'Cliente',
      type: 'Tipo', created: 'Creado', updated: 'Actualizado',
      pagination_prev: 'Anterior', pagination_next: 'Siguiente',
      page_of: 'Página {{page}} de {{pages}}', notes: 'Notas',
      simulate: 'Simular', export: 'Exportar', delete: 'Eliminar' },
    search: { placeholder: 'Buscar por # de orden, nombre, email, teléfono o usuario TikTok…',
      start_typing: 'Escribe para buscar en toda la plataforma',
      start_typing_hint: 'Órdenes · Liquidaciones · Clientes',
      group_orders: 'Órdenes',
      group_payouts: 'Payouts del banco',
      group_deposit_refs: 'Payouts / Depósitos',
      deposit_ref_in_payout: '{{label}} está en el payout {{payout}}',
      group_settlements: 'Statements / Liquidaciones',
      group_customers: 'Clientes',
      not_found_title: 'La orden “{{q}}” NO está en la plataforma',
      not_found_subtitle: 'No encontramos coincidencias. Si es una orden reciente de TikTok podemos sincronizarla ahora.',
      sync_from_tiktok: 'Sincronizar ahora desde TikTok',
      sync_done: 'Sincronización completada — {{pulled}} órdenes leídas, {{processed}} procesadas',
      sync_error: 'No se pudo sincronizar con TikTok',
      sync_confirm_title: '¿Sincronizar manualmente desde TikTok?',
      sync_confirm_body: 'El sistema YA sincroniza solo cada 10 minutos aplicando las reglas de seguridad (espera de 1 h, filtro de datos del comprador y fecha de corte). Esta sincronización manual solo trae lo que falta — no fuerza la creación de Estimates que el sistema no crearía. ¿Continuar?',
      sync_confirm_accept: 'Sí, sincronizar',
      results_count: '{{count}} resultados · ↵ para abrir',
      open_palette: 'Abrir búsqueda global' },
    status: { synced: 'Sincronizado', processed: 'Sincronizado',
      pending: 'Pendiente', failed: 'Fallido', cancelled: 'Cancelado',
      cancelled_skipped: 'Cancelado',
      cancelled_after_sync: 'Cancelada tras sincronizar',
      refunded: 'Reembolsado', manual_review: 'Revisión', retrying: 'Reintentando',
      transfer_done: 'Transferida', open: 'Abierto', paid: 'Pagado',
      pending_reconciliation: 'Pend. reconciliación', reconciled: 'Reconciliada',
      shortage: 'Faltante', overage: 'Sobrante',
      completed: 'Completa', waiting_label: 'Esperando etiqueta',
      pending_review: 'Pendiente revisión', committed: 'Aprobado',
      reconciled_externally: 'Reconciliado fuera del sistema',
      deposit_deleted_in_qbo: 'Depósito borrado en QuickBooks' },
    alert_type: {
      order_cancelled_after_sync: 'Orden cancelada tras sincronizar',
      aged_clearing_alert: 'Saldo pendiente > 7 días',
      email: 'Email',
    },
    dashboard: { title: 'Inicio', subtitle: 'Indicadores y actividad reciente',
      orders_today: 'Órdenes de hoy', synced: 'Sincronizadas',
      pending: 'Pendientes', failed: 'Fallidas',
      settlements_month: 'Liquidaciones del mes',
      clearing_balance: 'Saldo clearing',
      aged_alerts: 'Alertas vencidas (>7d)',
      manual_review: 'En revisión manual',
      activity_recent_orders: 'Órdenes recientes',
      activity_recent_settlements: 'Liquidaciones recientes',
      activity_recent_alerts: 'Alertas recientes',
      clearing_health: 'Salud del clearing (últimos 14 días)',
      simulate_orders: 'Generar órdenes demo',
      simulate_settlement: 'Generar liquidación demo' },
    orders: { title: 'Órdenes', subtitle: 'Ventas sincronizadas desde TikTok Shop',
      filter_status: 'Estado', filter_date_from: 'Desde', filter_date_to: 'Hasta',
      filter_auction: 'Subasta #',
      search_placeholder: 'Buscar por # de orden, nombre, email, teléfono o # de subasta',
      column_order: 'Orden TikTok', column_auction: 'Subasta #', column_date: 'Fecha', column_customer: 'Cliente',
      column_total: 'Total', column_status: 'Estado',
      column_qbo: 'Orden QBO', column_actions: 'Acciones',
      detail_title: 'Detalle de orden', detail_so: 'Sales Order',
      detail_invoice: 'Factura', detail_customer: 'Cliente',
      invoice_number: 'Nº de factura', invoice_id: 'ID factura QBO',
      invoice_carrier: 'Transportista',
      retry: 'Reintentar', copy_id: 'Copiar # de orden completo', copied: 'Copiado',
      export: 'Descargar', export_done: 'Reporte descargado',
      export_error: 'No se pudo descargar el reporte' },
    settlements: { title: 'Liquidaciones',
      subtitle: 'Reconciliación de pagos TikTok contra QuickBooks',
      column_id: 'ID Liquidación', column_date: 'Fecha',
      column_payments: 'Pagos', column_fees: 'Cargos',
      column_refunds: 'Reembolsos', column_payout: 'Net payout esperado',
      column_status: 'Estado',
      detail_tabs_summary: 'Resumen', detail_tabs_fees: 'Cargos',
      detail_tabs_refunds: 'Reembolsos', detail_tabs_je: 'Asiento (JE)',
      detail_tabs_transfer: 'Transferencia',
      record_transfer: 'Registrar transferencia bancaria',
      search_placeholder: 'Buscar por Statement ID…',
      filter_from: 'Desde',
      filter_to: 'Hasta',
      filter_clear: 'Limpiar filtros',
      bank_amount: 'Monto depositado en banco' },
    manual_review: { title: 'Cola de revisión manual',
      subtitle: 'Casos ambiguos que requieren decisión humana',
      type_ambiguous_match: 'Cliente ambiguo (múltiples coincidencias)',
      type_name_zip_match_diff_street: 'Mismo nombre + ZIP, distinta calle',
      type_missing_invoice: 'Factura faltante en liquidación',
      type_unmapped_sku: 'SKU sin mapeo',
      type_uncategorized_charge: 'Cargo sin categoria',
      type_return_processed: 'Devolución procesada',
      type_order_sync_failed: 'Sincronización de orden fallida',
      type_buyer_name_review: 'Nombre de comprador a revisar',
      type_identity_review: 'Identidad del comprador a revisar',
      identity_order_side: 'Orden de TikTok',
      identity_phone: 'Teléfono',
      identity_user_id: 'Cuenta de TikTok',
      identity_address: 'Dirección',
      identity_transactions: 'Transacciones',
      identity_active: 'Activo en QBO',
      identity_inactive: 'INACTIVO en QBO',
      identity_created_separate: 'Cliente separado creado',
      identity_same_button: 'Es la misma persona',
      identity_distinct_button: 'Son personas distintas',
      identity_disclaimer: 'Esto no modifica facturas ya emitidas ni fusiona clientes en QuickBooks: solo define a qué ficha van las PRÓXIMAS órdenes. La fusión en QuickBooks la decide la contadora a mano.',
      identity_same_success: 'Vínculo guardado — las próximas órdenes van a esa ficha',
      identity_distinct_success: 'Confirmado como personas distintas',
      identity_resolve_error: 'No se pudo resolver la revisión de identidad',
      identity_resolved_to: 'Resuelto hacia el cliente',
      status_identity_same_person: 'Misma persona',
      status_identity_distinct: 'Personas distintas',
      filter_status: 'Estado', status_pending: 'Pendiente',
      status_archived: 'Archivado', status_resolved: 'Resuelto',
      status_all: 'Todos', status_approved: 'Aprobado',
      status_rejected: 'Rechazado', status_merged: 'Fusionado',
      status_forwarded: 'Reenviado', status_resolved_by_retry: 'Resuelto (reintento)',
      status_auto_resolved: 'Auto-resuelto', status_discarded: 'Descartado',
      status_resolved_already_processed: 'Ya procesado por otra vía',
      sort_newest: 'Más reciente primero',
      sort_oldest: 'Más antiguo primero',
      cleanup_button: 'Limpiar pre-cutoff',
      cleanup_confirm: 'Se archivarán {{count}} ítems obsoletos (pre-cutoff). Esto NO afecta órdenes ni QuickBooks, solo la cola de revisión. ¿Continuar?',
      cleanup_none: 'No hay ítems obsoletos para limpiar.',
      cleanup_done: 'Limpieza completada — {{count}} ítems archivados.',
      cleanup_error: 'No se pudo ejecutar la limpieza.',
      target_customer: 'Cliente destino (merge)',
      retry_sync: 'Reintentar sincronización',
      retry_sync_success: 'Orden re-sincronizada con QBO',
      retry_sync_error: 'No se pudo reintentar la sincronización',
      buyer_name_reason_masked: 'TikTok todavía no reveló el nombre',
      buyer_name_reason_username: 'El comprador puso su usuario como nombre',
      buyer_name_tiktok_sent: 'Nombre enviado por TikTok',
      buyer_name_edit_label: 'Nombre a usar',
      buyer_data_help: 'Completá los datos que veas en el panel de TikTok. Lo que cargues acá se usa para el estimado y no lo pisa una actualización posterior de TikTok. Los campos que dejes vacíos conservan lo que ya tenía la orden.',
      buyer_phone_label: 'Teléfono',
      buyer_phone_invalid: 'El teléfono tiene que ser el número (10 dígitos, ej. 612 403 2250), no el nombre.', // Fix 60
      buyer_address1_label: 'Dirección',
      buyer_address2_label: 'Dirección (línea 2)',
      buyer_city_label: 'Ciudad',
      buyer_state_label: 'Estado',
      buyer_zip_label: 'Código postal',
      buyer_name_approve_button: 'Aprobar y crear estimado',
      buyer_name_already_processed: 'TikTok ya había liberado los datos y el estimado se creó automáticamente. No se creó otro.',
      buyer_name_locked: 'Esta orden se está procesando en este momento. Refrescá en unos segundos.',
      status_resolved_auto_processed: 'Creado automáticamente',
      buyer_name_discard_button: 'Descartar',
      buyer_name_approve_success: 'Estimado creado correctamente',
      buyer_name_approve_error: 'No se pudo crear el estimado',
      buyer_name_discard_success: 'Caso descartado',
      buyer_name_discard_error: 'No se pudo descartar el caso',
      // Fix 34 (2026-09-12): importar el export de órdenes de TikTok Seller Center.
      import_button: 'Importar export de TikTok',
      import_title: 'Importar export de órdenes de TikTok',
      import_help: 'Exportá las órdenes desde Seller Center (Orders → Export), completá en el archivo las columnas Recipient, Phone #, Address Line 1, Address Line 2 y City con lo que ves en el panel, y subilo acá. Las órdenes que sigan enmascaradas quedan pendientes; el resto se carga y los estimados se crean solos.',
      import_columns_hint: 'Acepta el CSV original o el mismo archivo guardado como .xlsx. No cambies los encabezados. Si Excel convirtió los números de orden (5,77E+17), volvé a exportar y completá sin convertir esa columna a número.',
      import_parsing: 'Leyendo el archivo…',
      import_col_order: 'Orden',
      import_col_name: 'Nombre',
      import_col_phone: 'Teléfono',
      import_col_address: 'Dirección',
      import_col_status: 'Resultado',
      import_status_ready: 'Lista para cargar',
      import_status_masked: 'Sigue enmascarada',
      import_status_name_invalid: 'Nombre inválido (usuario o "TikTok Customer")',
      import_status_already_processed: 'Ya tiene estimado',
      import_status_cancelled: 'Cancelada',
      import_status_not_in_system: 'No está en el sistema',
      import_status_before_cutoff: 'Histórica (no se procesa)',
      import_status_order_id_invalid: 'Número de orden inválido',
      import_status_order_id_damaged_by_excel: 'Número de orden dañado por Excel',
      import_status_order_id_empty: 'Sin número de orden',
      import_masked_fields: 'Faltan',
      import_field_name: 'nombre',
      import_field_phone: 'teléfono',
      import_field_line1: 'dirección',
      import_field_city: 'ciudad',
      import_note_phone_missing: 'Sin teléfono: se carga igual',
      import_note_city_missing: 'Sin ciudad: se carga igual',
      import_note_updates_previous_manual_data: 'Reemplaza datos cargados antes a mano',
      import_note_waiting_status: 'Se guarda; el estimado se crea cuando la orden esté lista para envío',
      import_note_waiting_delay: 'Se guarda; el estimado se crea al cumplirse el tiempo de espera',
      import_note_sku_mismatch: 'El número de subasta no coincide con la orden: revisá la fila',
      import_note_conflicting_rows: 'Filas de la misma orden con datos distintos: se usa el primero',
      import_apply_button: 'Cargar datos y crear {{count}} estimados',
      import_nothing_ready: 'No hay órdenes listas para cargar',
      import_cancel: 'Cancelar',
      import_tracking: 'Creando estimados… {{done}} de {{total}}',
      import_done: 'Listo: {{done}} estimados creados, {{pending}} pendientes',
      import_pending_hint: 'Las pendientes se procesan solas en el próximo ciclo automático (cada 10 minutos).',
      import_frozen: 'Las escrituras a QuickBooks están congeladas: los datos quedaron guardados y los estimados se crean cuando se descongele.',
      import_sync_error: 'El ciclo de sincronización falló; los datos quedaron guardados y se reintenta en el próximo ciclo',
      import_error: 'No se pudo procesar el archivo',
      import_close: 'Cerrar',
      // Fix 36 (2026-09-17): autocompletado de compradores ya conocidos.
      autofill_label: 'Autocompletar compradores conocidos',
      autofill_help: 'Cuando la orden es de un comprador que ya nos compró antes y TODO coincide (iniciales y largo del nombre, código de área y últimos dígitos del teléfono, número de calle, ciudad, código postal y nombre de perfil), el sistema completa los datos y crea el estimado solo: esa orden no llega acá. Si algo no coincide o el comprador es nuevo, la orden entra a esta pantalla como siempre.',
      prefilled_banner: 'Datos cargados automáticamente desde la compra anterior (orden {{order}}). Revisá y aprobá.',
      cannot_approve: 'No se puede aprobar todavía — falta completar:',
      autofill_on: 'Autocompletado activado',
      autofill_off: 'Autocompletado desactivado',
      autofill_error: 'No se pudo cambiar el autocompletado',
      known_buyer_match: 'Comprador conocido — coincide todo',
      known_buyer_partial: 'Comprador parecido — revisar',
      known_buyer_previous: '{{count}} compras anteriores',
      known_buyer_use: 'Usar estos datos',
      known_buyer_used: 'Datos cargados en el formulario — revisá y aprobá',
      known_buyer_mismatch: 'No coincide',
      known_buyer_field_name: 'nombre',
      known_buyer_field_phone: 'teléfono',
      known_buyer_field_line1: 'dirección',
      known_buyer_field_line2: 'dirección línea 2',
      known_buyer_field_city: 'ciudad',
      known_buyer_field_zip: 'código postal',
      no_pending: 'No hay casos pendientes en este momento.' },
    clearing: { title: 'Salud del clearing',
      subtitle: 'Balance esperado: 0 dentro de 48 h post-liquidación',
      unreconciled: 'Liquidaciones no conciliadas',
      aged_alerts: 'Alertas >7 días',
      column_settlement: 'Liquidación', column_age: 'Edad (días)',
      column_balance: 'Balance', column_payments: 'Pagos',
      column_je: 'JE', column_transferred: 'Transferido' },
    logs: { title: 'Logs y alertas', subtitle: 'Auditoría completa con correlation_id',
      tab_logs: 'Logs', tab_alerts: 'Alertas',
      level: 'Nivel', correlation_id: 'Correlation ID' },
    config: { title: 'Configuración',
      subtitle: 'Mapeos de productos, cuentas QBO y usuarios',
      tab_products: 'Productos (SKU → Item QBO)',
      tab_accounts: 'Plan de cuentas QBO',
      tab_adjustment_accounts: 'Cuentas de ajuste',
      adjustment_accounts_help: 'Estas son las cuentas que aparecen al crear un ajuste manual o al reasignar la cuenta de una línea en un depósito. Elegí una cuenta de tu plan de cuentas de QuickBooks para agregarla. No se crea ninguna cuenta en QuickBooks: solo se habilita una que ya existe.',
      adjustment_accounts_pick: 'Elegí una cuenta de QuickBooks',
      adjustment_accounts_add: 'Agregar al selector',
      adjustment_accounts_name: 'Cuenta',
      adjustment_accounts_origin: 'Origen',
      adjustment_accounts_source_custom: 'Agregada por ustedes',
      adjustment_accounts_source_builtin: 'Del sistema',
      adjustment_accounts_missing: 'no existe en QuickBooks',
      adjustment_accounts_added: 'Cuenta agregada al selector',
      adjustment_accounts_removed: 'Cuenta quitada del selector',
      tab_users: 'Usuarios',
      seed_accounts: 'Sembrar plan de cuentas',
      add_user: 'Agregar usuario', new_mapping: 'Nuevo mapeo' },
    health: { title: 'Estado del sistema',
      subtitle: 'Conectividad TikTok / QBO / MongoDB',
      mode: 'Modo del adaptador', env: 'Ambiente',
      last_settlement: 'Última liquidación' },
    integrations: {
      title: 'Integraciones',
      subtitle: 'Conexión y sincronización con TikTok Shop y QuickBooks Online',
      tiktok_subtitle: 'OAuth, sincronización de catálogo, órdenes y liquidaciones',
      connected: 'Conectado', not_connected: 'Sin conectar',
      live_ok: 'API en vivo OK', live_fail: 'API en vivo falla',
      empty_not_connected: 'TikTok Shop no está conectado todavía. Pídele al dueño de la cuenta principal que autorice la app.',
      connect_tiktok: 'Conectar TikTok Shop',
      seller_name: 'Vendedor', seller_region: 'Región',
      shop_id: 'Shop ID', shop_cipher: 'Shop cipher',
      missing: 'Falta', never: 'Nunca',
      access_expires: 'Access token expira', refresh_expires: 'Refresh token expira',
      authorized_at: 'Autorizado el', refreshed_at: 'Último refresh',
      scopes: 'Permisos otorgados',
      live_ping_ok: 'Ping en vivo a TikTok exitoso',
      live_ping_fail: 'TikTok rechazó el ping',
      shops: 'tiendas',
      actions: 'Acciones',
      refresh_tokens: 'Refrescar tokens',
      discover_shops: 'Descubrir tiendas',
      sync_products: 'Sync productos',
      sync_orders: 'Sync órdenes',
      sync_settlements: 'Sync liquidaciones',
      open_partner_center: 'Abrir Partner Center',
      cipher_hint: 'Ejecuta "Descubrir tiendas" primero para obtener el shop_cipher.',
      recent_logs: 'Logs recientes de sincronización',
      no_logs: 'Aún no hay logs de sincronización.',
      source: 'Fuente', level: 'Nivel', message: 'Mensaje',
      new: 'nuevos', processed: 'procesadas',
      toast_refresh_ok: 'Tokens refrescados',
      toast_refresh_err: 'Error refrescando tokens',
      toast_shops_ok: 'Tiendas descubiertas',
      toast_shops_err: 'Error descubriendo tiendas',
      toast_products_ok: 'Productos sincronizados',
      toast_products_err: 'Error sincronizando productos',
      toast_orders_ok: 'Órdenes sincronizadas',
      toast_orders_err: 'Error sincronizando órdenes',
      toast_settlements_ok: 'Liquidaciones sincronizadas',
      toast_settlements_err: 'Error sincronizando liquidaciones',
      // QBO
      qbo_subtitle: 'OAuth, libro contable y reconciliación de liquidaciones',
      qbo_card_title: 'QuickBooks Online',
      qbo_app_missing: 'Falta configurar QBO_CLIENT_ID y QBO_CLIENT_SECRET en el backend.',
      qbo_not_connected: 'QuickBooks Online aún no está autorizado. Conecta un realm sandbox o producción.',
      qbo_connect: 'Conectar QuickBooks',
      qbo_environment: 'Ambiente',
      qbo_company: 'Empresa',
      qbo_realm: 'Realm ID',
      qbo_managed_accounts: 'Cuentas gestionadas',
      qbo_setup_chart: 'Crear plan de cuentas',
      qbo_disconnect: 'Desconectar',
      qbo_bootstrap_done: 'Plan de cuentas listo: {{created}} creadas, {{skipped}} ya existían',
      qbo_bootstrap_err: 'Error creando plan de cuentas',
      qbo_disconnect_confirm: '¿Seguro que querés desconectar QuickBooks?',
      qbo_disconnected: 'QuickBooks desconectado',
    },
    deposits: {
      title: 'Depósitos banco',
      subtitle: 'Reconciliación de payouts TikTok → QuickBooks Bank Deposit',
      subtitle_detail: 'Revisión de payout',
      tab_pending: 'Pendientes',
      tab_committed: 'Aprobados',
      tab_external: 'Reconciliado fuera del sistema',
      col_invoices: '# Facturas',
      col_balanced: 'Cuadra',
      filter_from: 'Desde',
      filter_to: 'Hasta',
      filter_clear: 'Limpiar filtro',
      search_payout_placeholder: 'Buscar por ID de payout, statement, MONTO, nº de factura u orden de TikTok…',
      bank_paid_on: 'Pagado al banco:',
      not_reconciled_title: 'Este payout todavía no está reconciliado',
      not_reconciled_subtitle: 'No encontramos un depósito creado para este payout todavía. Puede que aún no haya pasado por el módulo de Depósitos banco.',
      col_account: 'Cuenta QBO',
      btn_review: 'Revisar',
      btn_reconcile_pending: 'Reconciliar pendientes',
      reconciling: 'Reconciliando…',
      btn_prepare_demo: 'Preparar demo',
      preparing_demo: 'Preparando…',
      demo_phase_backfill: 'Trayendo órdenes…',
      demo_phase_invoicing: 'Facturando…',
      demo_phase_refreshing: 'Refrescando…',
      demo_already_running: 'Ya hay una preparación en curso',
      demo_error: 'Error al preparar el demo',
      btn_download: 'Descargar',
      export_include_all: 'Incluir todos (pendientes + aprobados)',
      export_done: 'depósitos exportados',
      export_error: 'Error al exportar depósitos',
      btn_commit: 'Aprobar y crear depósito en QBO',
      empty_pending: 'No hay payouts pendientes de revisión.',
      empty_committed: 'No hay payouts aprobados todavía.',
      empty_payments: 'Sin facturas matcheadas.',
      section_payments: 'Facturas a marcar como PAGADAS',
      section_fees: 'Fees (se restan)',
      stat_gross: 'Ventas brutas',
      stat_fees: 'Total fees',
      stat_net: 'Net depositado',
      stat_bank: 'Cuenta bancaria',
      stat_clawbacks: 'Clawbacks',
      stat_reserve: 'Reserva TikTok',
      stat_adjustment: 'Ajuste TikTok',
      banner_balanced: 'Cuadra (diff 0)',
      banner_unbalanced: 'No cuadra — diferencia de',
      warning_title: 'Requieren revisión manual',
      warning_unmatched: 'Órdenes sin factura',
      warning_refunds: 'Devoluciones / clawbacks',
      warning_unmatched_blocking: 'Órdenes SIN factura — no se pueden reconciliar:',
      section_special_cases: 'Casos especiales',
      section_special_cases_hint: '— revisá antes de aprobar',
      case_clawbacks: 'Devoluciones / Clawbacks',
      case_reserve: 'Reserva TikTok',
      case_adjustment: 'Ajuste TikTok',
      adjustment_uncategorized: 'Sin clasificar',
      case_shipping_only: 'Solo-shipping (revenue 0)',
      case_unmatched: 'Sin factura (unmatched)',
      net_to_bank: 'Net al banco',
      account_missing: 'Cuenta no encontrada en QBO',
      shipping_protection_label: 'Reembolsos de Shipping Protection', // Fix 62
      already_committed: 'Ya aprobado',
      commit_disabled_hint: 'Deshabilitado: el preview no cuadra',
      confirm_title: '¿Confirmar creación del depósito?',
      confirm_body: 'Vas a crear el depósito por {{net}}, marcando {{count}} factura/s como pagadas en QuickBooks. ¿Confirmás?',
      toast_committed: 'Depósito creado —',
      toast_error: 'Error al crear el depósito en QBO',
      access_denied: 'Acceso restringido a roles admin y contador.',
      verify_section_title: 'Verificar contra TikTok',
      verify_section_hint: 'Subí el Excel oficial de TikTok (Seller Center → Income) para comparar contra lo que tenemos acá',
      verify_dropzone_cta: 'Subí el Excel de TikTok',
      verify_dropzone_sub: 'Arrastrá el archivo .xlsx aquí o hacé clic para elegirlo',
      verify_uploading: 'Verificando…',
      verify_reverify: 'Volver a verificar',
      verify_match_banner: '✓ Coincide con TikTok',
      verify_diff_banner: 'Diferencias encontradas',
      verify_toast_match: 'El Excel de TikTok coincide con la plataforma',
      verify_toast_diff: 'Se encontraron diferencias contra el Excel de TikTok',
      verify_error: 'Error al verificar el Excel',
      verify_invalid_ext: 'Subí un archivo .xlsx',
      verify_last_at: 'Última verificación:',
      verify_col_field: 'Campo',
      verify_col_platform: 'Plataforma',
      verify_col_diff: 'Diferencia',
      verify_orders_matched: 'Órdenes que coinciden',
      verify_excel_rows_read: 'Filas leídas del Excel',
      verify_rows_this_statement: 'de este statement',
      verify_orders_in_excel: 'órdenes en Excel',
      verify_missing_in_platform: 'En TikTok pero no en la plataforma',
      verify_missing_in_tiktok: 'En la plataforma pero no en el Excel de TikTok',
      verify_amount_mismatches: 'Montos distintos',
      // Ajustes manuales (Fase 5)
      why_not_balanced: '¿Por qué no cuadra?',
      why_missing_amount: 'Faltan',
      why_unmatched_orders: 'órdenes sin factura por',
      why_manual_adj_applied: 'Ajustes manuales ya aplicados',
      why_diff_total: 'Diferencia total',
      manual_adj_section: 'Ajustes manuales',
      manual_adj_add_btn: 'Agregar ajuste manual',
      manual_adj_dialog_title: 'Nuevo ajuste manual',
      manual_adj_dialog_desc: 'Se suma a la reconciliación del payout. No escribe nada en QuickBooks hasta que apruebes el depósito.',
      manual_adj_amount: 'Monto',
      manual_adj_amount_hint: 'Positivo suma, negativo resta. Pre-cargado con la diferencia restante.',
      manual_adj_account: 'Cuenta',
      manual_adj_account_placeholder: 'Elegí una cuenta',
      manual_adj_note: 'Nota (opcional)',
      manual_adj_save: 'Guardar ajuste',
      manual_adj_saving: 'Guardando…',
      manual_adj_deleted: 'Ajuste eliminado',
      manual_adj_added: 'Ajuste manual agregado',
      manual_adj_error: 'Error al guardar el ajuste',
      manual_adj_delete_error: 'Error al eliminar el ajuste',
      manual_adj_empty: 'Sin ajustes manuales todavía.',
      manual_adj_by: 'por',
      manual_adj_readonly_hint: 'Depósito ya aprobado — los ajustes quedan de solo lectura.',
      manual_adj_readonly_hint_external: 'Payout reconciliado fuera del sistema — los ajustes quedan de solo lectura.',
      line_account_change: 'Cambiar cuenta',
      line_account_reassign_title: 'Reasignar cuenta',
      line_account_error: 'Error al reasignar la cuenta',
      line_account_updated: 'Cuenta reasignada',
      account_eligible_missing: 'no encontrada en QBO',
      account_reassign_help: 'Usá el botón "Cambiar cuenta" en cualquier línea para reasignarla a otra cuenta elegible del depósito.',
      // División de una línea de ajuste entre varias cuentas (Fix 31)
      line_split_btn: 'Dividir',
      line_split_remove_btn: 'Quitar división',
      line_split_title: 'Dividir línea de ajuste',
      line_split_desc: 'Repartí este monto entre varias cuentas de QuickBooks',
      line_split_pick_account: 'Elegí una cuenta',
      line_split_note_placeholder: 'Nota (opcional)',
      line_split_add_part: 'Agregar parte',
      line_split_remaining: 'Restante',
      line_split_save: 'Guardar división',
      line_split_saved: 'Línea dividida',
      line_split_removed: 'División eliminada',
      line_split_error: 'Error al guardar la división',
      line_split_mismatch: 'La suma de las partes ({{parts}}) no coincide con el monto de la línea ({{line}}) — no se guardó nada.',
      line_split_invalid: 'La división ya no coincide con el monto — se muestra la línea completa',
      line_split_part_label: 'parte {{n}}/{{total}}',
      // Reconciliado fuera del sistema (Fase 8)
      empty_external: 'No hay payouts marcados como reconciliados fuera del sistema.',
      btn_mark_reconciled: 'Ya reconciliado en QuickBooks',
      mark_reconciled_dialog_title: '¿Marcar como reconciliado fuera del sistema?',
      mark_reconciled_dialog_desc: 'Esto NO crea nada en QuickBooks. Solo marca este payout como ya reconciliado por vos para que no vuelva a aparecer en Pendientes.',
      mark_reconciled_note: 'Nota (opcional)',
      mark_reconciled_qbo_id: 'N° de depósito en QBO (opcional)',
      mark_reconciled_qbo_id_placeholder: 'Ej: 4521',
      mark_reconciled_confirm: 'Sí, marcar como reconciliado',
      mark_reconciled_success: 'Payout marcado como reconciliado fuera del sistema',
      mark_reconciled_error: 'Error al marcar el payout',
      externally_reconciled_banner: 'Reconciliado fuera del sistema',
      externally_reconciled_by: 'por',
      externally_reconciled_linked: 'Depósito QBO vinculado',
      unmark_reconciled_btn: 'Deshacer',
      unmark_reconciled_confirm_title: '¿Deshacer la marca de reconciliado?',
      unmark_reconciled_confirm_desc: 'El payout vuelve a Pendientes. Esto no afecta nada en QuickBooks.',
      unmark_reconciled_success: 'Marca revertida — el payout volvió a Pendientes',
      unmark_reconciled_error: 'Error al revertir la marca',
      bulk_mark_btn: 'Marcar antiguos como reconciliados…',
      bulk_mark_title: 'Marcar payouts antiguos como reconciliados',
      bulk_mark_dialog_desc: 'Esto NO crea nada en QuickBooks. Solo marca estos payouts como ya reconciliados para que no aparezcan en Pendientes.',
      bulk_mark_before_label: 'Marcar todos los payouts anteriores a:',
      bulk_mark_count_suffix: 'payouts pendientes entran en el criterio',
      bulk_mark_none: 'Ningún payout pendiente entra en el criterio.',
      bulk_mark_note_default: 'Reconciliado manualmente en QB antes de la integración',
      bulk_mark_confirm_prefix: 'Sí, marcar',
      bulk_mark_confirm_suffix: 'payouts',
      bulk_mark_selected_btn: 'Marcar seleccionados como reconciliados',
      bulk_mark_success_suffix: 'marcados',
      bulk_mark_error: 'Error al marcar en lote',
      commit_disabled_external_hint: 'Deshabilitado: este payout ya está reconciliado fuera del sistema',
      // Anti-duplicado (Fase 8)
      duplicate_dialog_title: 'Posible depósito duplicado en QBO',
      duplicate_dialog_desc: 'Encontramos depósito(s) en QuickBooks con fecha o monto parecido a este payout. Revisá antes de continuar:',
      duplicate_col_id: 'ID QBO',
      duplicate_col_date: 'Fecha',
      duplicate_col_amount: 'Monto',
      duplicate_col_note: 'Nota',
      duplicate_link_btn: 'Es este → vincular',
      duplicate_force_btn: 'No es el mismo → crear igual',
      duplicate_link_success: 'Payout vinculado al depósito existente',
      duplicate_link_error: 'Error al vincular el depósito',
      // Vista por pago bancario (agrupación por payment_id)
      view_statements: 'Statements',
      view_payouts: 'Payouts del banco',
      view_payouts_hint: 'Agrupados por pago bancario — el total de cada grupo es el monto exacto que entró al banco',
      col_payment_id: 'Pago bancario (payment ID)',
      col_statements: '# Statements',
      col_total_bank: 'Total al banco',
      no_payment_id: 'Sin payment ID de TikTok',
      group_empty: 'No hay payouts bancarios para mostrar.',
      group_expand: 'Ver statements',
      group_commit_btn: 'Aprobar payout completo',
      group_recommit_btn: 'Volver a aprobar (crear depósito de nuevo)',
      deposit_deleted_message: 'El depósito de este payout fue borrado en QuickBooks. Podés volver a aprobarlo para crearlo de nuevo.',
      group_commit_title: '¿Aprobar el payout bancario completo?',
      group_commit_desc: 'Se va a crear UN SOLO Bank Deposit en QuickBooks por el total del payout, combinando las líneas de todos sus statements. Así el Match en QBO queda 1 a 1 con la línea del banco.',
      group_commit_date_label: 'Fecha del depósito (día que entró al banco)',
      group_commit_date_hint_known: 'Default: fecha de pago informada por TikTok.',
      group_commit_date_hint_unknown: 'TikTok no informó la fecha de pago — default: statement más nuevo. Ajustala según el extracto.',
      group_commit_confirm: 'Sí, crear el depósito',
      group_commit_success: 'Payout aprobado — depósito creado',
      payments_recreated_toast: 'pago(s) habían sido borrados a mano en QuickBooks y se recrearon automáticamente',
      group_commit_progress: 'Progreso',
      link_invoice_btn: 'Asignar factura',
      link_invoice_title: 'Asignar una factura existente',
      link_invoice_desc: 'Ingresá el número de factura (DocNumber) que ves en QuickBooks para esta orden. Se valida contra QuickBooks antes de vincular.',
      link_invoice_placeholder: 'Ej: 8440',
      link_invoice_confirm: 'Vincular factura',
      link_invoice_success: 'Factura vinculada',
      link_invoice_order_amount: 'Monto de la orden',
      link_invoice_reason: 'Motivo',
      link_invoice_reason_no_estimate: 'sin estimate en el sistema',
      link_invoice_reason_no_invoice: 'estimate sin factura vinculada',
      // Fix 64 (2026-10-26)
      change_invoice_btn: 'Cambiar factura',
      link_invoice_reason_change: 'cambiar la factura {{doc}} ({{n}} orden/es de esta línea)',
      link_invoice_amount_mismatch: 'La factura {{doc}} es de {{invoice}} y la orden es de {{order}} — podés vincularla igual',
      link_invoice_error: 'No se pudo vincular la factura',
      group_commit_error: 'Error al aprobar el payout completo',
      group_blocked_title: 'No se puede aprobar el payout completo todavía',
      group_blocked_hint: 'Resolvé estos statements primero (o aprobalos individualmente):',
      blocked_payments_title: 'Pagos ya incluidos en otro depósito de QuickBooks',
      blocked_payments_desc: 'Estos pagos ya fueron consumidos por OTRO Bank Deposit en QuickBooks y no se pueden usar de nuevo. Lo recomendado es resolver o deshacer ese depósito viejo en QuickBooks antes de reintentar.',
      blocked_payments_col_invoice: 'Factura',
      blocked_payments_col_customer: 'Cliente',
      blocked_payments_col_amount: 'Monto',
      blocked_payments_col_deposit: 'Depósito que la contiene',
      blocked_payments_unknown_deposit: 'Ya aplicada a otro depósito (no se pudo identificar cuál)',
      blocked_payments_payout_total: 'Total del payout',
      blocked_payments_excluded_total: 'Monto excluido',
      blocked_payments_result_total: 'Total del depósito a crear',
      blocked_payments_warning: 'Este depósito NO va a coincidir con la línea del banco por la diferencia excluida.',
      blocked_payments_exclude_btn: 'Excluir y crear con el resto',
      blocked_payments_close_btn: 'Cerrar y resolver en QuickBooks',
      blocked_payments_exclude_success: 'Depósito creado excluyendo los pagos bloqueados',
      blocked_payments_exclude_error: 'Error al crear el depósito excluyendo los pagos bloqueados',
      group_mark_btn: 'Marcar payout completo como ya reconciliado',
      group_mark_title: '¿Marcar todo el payout como reconciliado en QuickBooks?',
      group_mark_desc: 'Esto NO crea nada en QuickBooks. Marca todos los statements pendientes de este payout como ya reconciliados por vos.',
      group_mark_confirm: 'Sí, marcar el payout',
      group_mark_success: 'statements del payout marcados',
      group_mark_error: 'Error al marcar el payout',
      blocker_not_balanced: 'no cuadra',
      blocker_sum_mismatch: 'la suma de los statements no da el monto del pago bancario',
      blocker_statement_missing: 'este statement todavía no tiene depósito generado (mirá abajo)',
      group_sum_mismatch: 'suma statements {{sum}} · dif {{diff}}',
      group_adj_add: 'Agregar ajuste del payout',
      group_adj_title: 'Ajuste del payout bancario',
      group_adj_desc: 'Cubre la diferencia entre lo que suman los statements y el monto que entró al banco. No modifica el balance de ningún statement: se agrega como una línea más del depósito al aprobar.',
      group_adj_bank: 'Monto acreditado en el banco',
      group_adj_statements: 'Suma de los statements',
      group_adj_missing: 'Falta para cerrar',
      group_adj_amount: 'Monto del ajuste',
      group_adj_account: 'Cuenta',
      group_adj_note: 'Nota (opcional)',
      group_adj_added: 'Ajuste agregado al payout',
      group_adj_removed: 'Ajuste eliminado',
      group_source_statement: 'sin confirmar por la API de payments de TikTok',
      blocker_already_committed: 'ya aprobado',
      blocker_reconciled_externally: 'reconciliado fuera del sistema',
      blocker_not_pending: 'no está pendiente',
      part_of_payout: 'Este statement es parte del pago bancario {{id}} de {{amount}}, junto con otros {{n}}.',
      part_of_payout_single: 'Este statement es el único del pago bancario {{id}} de {{amount}}.',
      view_group_btn: 'Ver el payout completo',
      aggregate_mode_title: 'Sin detalle de órdenes disponible (TikTok ya no expone las transacciones de este statement).',
      aggregate_mode_desc: 'Depósito agregado: no marca facturas como pagadas. Se registra la venta total, los fees a sus cuentas y el neto al banco.',
      adjustment_only_title: 'Ajuste de TikTok (sin órdenes asociadas) — típicamente adelanto o recuperación del Early Settlement',
      adjustment_only_desc: 'El monto completo va a la cuenta de ajuste (reasignable) y el neto al banco. No hay facturas para marcar como pagadas.',
      adjustment_only_badge: 'Ajuste (sin órdenes)',
      backfill_started: 'Backfill iniciado en background',
      backfill_pulling: 'Bajando statements de TikTok…',
      backfill_empty_ranges: 'TikTok no devolvió statements en:',
      backfill_payments: '{{n}} pagos del banco bajados de TikTok',
      backfill_payments_empty: 'TikTok no devolvió pagos (payments) para el rango — mirá Logs → tiktok.payments_pull.raw',
      backfill_running: 'Reconciliando {{done}}/{{total}}…',
      backfill_done: 'Backfill terminado — {{reconciled}} reconciliados ({{balanced}} cuadran / {{unbalanced}} no)',
      backfill_error: 'El backfill terminó con error',
      backfill_already_running: 'Ya hay un backfill en curso',
      reviewed_badge: 'Revisado ✓',
      mark_reviewed: 'Marcar como revisado',
      unmark_reviewed: 'Quitar revisado',
      review_marked: 'Statement marcado como revisado',
      review_unmarked: 'Se quitó la marca de revisado',
      review_error: 'No se pudo cambiar la marca de revisado',
      reviewed_progress: '{{done}}/{{total}} revisados',
      reviewed_meta: 'Revisado por {{by}} · {{at}}',
      missing_statements_title: 'Statements de este payout que todavía no tienen depósito:',
      not_processed_yet: 'Sin procesar — TikTok no devuelve el detalle',
      statement_not_downloaded: 'Todavía no está en el sistema — corré "Reconciliar pendientes"',
      generate_aggregate_btn: 'Generar depósito agregado',
      generate_aggregate_hint: 'Usa los totales del statement (sin lista de facturas). No escribe nada en QuickBooks.',
      generate_aggregate_success: 'Depósito agregado generado para el statement {{id}}',
      generate_aggregate_error: 'No se pudo generar el depósito agregado',
      statement_attempts: '{{n}} intentos sin transacciones',
      unprocessed_search_title: 'Statements encontrados sin depósito generado',
      find_by_title: 'Coincidencias dentro de payouts',
      find_by_hint: 'Facturas y órdenes que están incluidas DENTRO de estos payouts (además de los resultados de la lista).',
      find_by_invoice: 'Factura {{n}}',
      find_by_order: 'Orden {{n}}',
      find_by_bank_group: 'grupo bancario {{n}}',
      find_by_kind_invoice: 'factura pagada',
      find_by_kind_order: 'orden facturada',
      find_by_kind_clawback: 'clawback / devolución',
      find_by_kind_shipping_only: 'solo envío',
      find_by_kind_unmatched: 'sin factura asociada',
      unprocessed_search_hint: 'Existen en el sistema pero TikTok no devolvió su detalle, por eso no aparecen como payouts.',
    },
  },
  en: {
    app_title: 'Integration Console',
    app_subtitle: 'TikTok Shop → QuickBooks Online',
    login: { title: 'Sign in', email: 'Email', password: 'Password',
      submit: 'Sign in', error: 'Invalid credentials',
      hint: 'Tip: admin@lovicreation.shop / Admin123!' },
    auth: { change_my_password: 'Change my password',
      current_password: 'Current password', new_password: 'New password',
      confirm_password: 'Confirm password', password_mismatch: "Passwords don't match",
      change_password_success: 'Password updated successfully',
      change_password_wrong_current: 'Current password is incorrect',
      change_password_error: 'Could not change the password',
      reset_password_title: 'Change user password',
      reset_password_success: 'Password updated',
      reset_password_error: 'Could not update the password' },
    nav: { dashboard: 'Home', orders: 'Orders', settlements: 'Settlements',
      sales_reports: 'Sales reports', // Fix 52 (2026-10-07)
      manual_review: 'Manual review', clearing: 'Clearing health',
      logs: 'Logs', config: 'Configuration', health: 'System health',
      integrations: 'Integrations', depositos: 'Bank deposits',
      duplicate_customers: 'Duplicate customers',
      new_customers: 'New customers',
      agenda: 'iCloud contacts',
      logout: 'Log out' },
    // Fix 51 (2026-10-06): shortcut to the iCloud contacts screen.
    agenda_link: {
      title: 'iCloud contacts',
      text: 'The connection, the sync and the contact lists are on the iCloud contacts screen.',
      button: 'Open iCloud contacts' },
    // Fix 46 (2026-10-02): New customers screen (read-only).
    new_customers: { title: 'New customers',
      subtitle: 'Buyers who made their first purchase in the period',
      preset_this_week: 'This week', preset_last_week: 'Last week',
      preset_this_month: 'This month', preset_last_month: 'Last month',
      preset_last_30: 'Last 30 days', preset_this_year: 'This year',
      from: 'From', to: 'To',
      kpi_new: 'New customers', kpi_repeat: 'Bought again',
      kpi_total: 'Total purchased', kpi_existing: 'Already in QuickBooks',
      definition: 'New customer: a TikTok buyer whose first non-cancelled purchase falls in the period and who did not already exist in QuickBooks.',
      existing_note: 'Buyers already in QuickBooks (bought before the platform or with another TikTok account) are not counted; they are in the Excel file, sheet "Ya existían en QuickBooks".',
      pending_note: 'with data pending in Manual Review.',
      chart_title: 'New customers', chart_by_day: 'per day',
      chart_by_week: 'per week', chart_by_month: 'per month',
      search_placeholder: 'Search by name, profile, phone, city or auction',
      col_date: '1st purchase', col_customer: 'Customer', col_nickname: 'TikTok profile',
      col_phone: 'Phone', col_location: 'City / State', col_auction: 'Auction #',
      col_first_total: '1st purchase total', col_orders: 'Purchases', col_total: 'Total purchased',
      pending_name: 'Data pending',
      download_excel: 'Excel', download_pdf: 'PDF',
      download_done: 'Report downloaded', download_error: 'Could not download the report',
      empty: 'No new customers in this period.',
      invalid_range: '"From" cannot be later than "To".',
      load_error: 'Could not load the report',
      showing: 'Showing', of: 'of', prev: 'Previous', next: 'Next' },
    dupes: {
      title: 'Duplicate customers',
      subtitle: 'The system proposes and explains; a person approves each case. Nothing runs on its own.',
      counter_total: 'Groups detected',
      counter_system: 'Resolvable by the system',
      counter_manual: 'Need a manual merge in QuickBooks',
      counter_likely_different: 'Probably different people',
      counter_resolved: 'Already resolved',
      status_pending: 'Pending', status_resolved: 'Resolved',
      status_ignored: 'Ignored', status_all: 'All',
      type_all: 'All cases',
      type_system: 'Resolvable by the system',
      type_manual: 'Manual merge in QuickBooks',
      type_likely_different: 'Probably different people',
      search_placeholder: 'Search by name or phone…',
      matched_user_id: 'Matches by TikTok account',
      matched_phone: 'Matches by phone',
      matched_name_address: 'Matches by name + address',
      in_identity_review: 'In identity review',
      role_keep: 'Kept', role_archive: 'Archived',
      role_neutral: 'Separate ficha',
      inactive: 'Inactive in QBO',
      transactions: 'transactions',
      open_balance: 'Open balance',
      no_phone: 'no phone', no_address: 'no address',
      no_user_id: 'no TikTok account',
      blocker_has_transactions: 'has transactions',
      blocker_open_balance: 'has an open balance',
      blocker_pending_payout: 'is in a pending payout',
      resolve: 'Resolve',
      howto_merge: 'How to merge in QuickBooks',
      not_same_person: 'Not the same person',
      ignore_hint: 'The group stops showing up in the pending list.',
      ignore_reason: 'Reason (optional)',
      confirm_title: 'Confirm the resolution',
      confirm_apply: 'Yes, apply',
      keeps: 'Keeps', archives: 'Archives',
      transactions_moved: 'Transactions moved',
      copy_keep_name: 'Copy the exact name',
      copied: 'Name copied',
      open_in_qbo: 'Open in QuickBooks',
      already_merged: 'I already merged it in QuickBooks',
      select_all_system: 'Select all resolvable',
      clear_selection: 'Clear selection',
      bulk_resolve: 'Resolve selected ({{n}})',
      bulk_confirm_title: 'Batch resolution',
      bulk_summary: 'You are about to resolve {{groups}} groups: {{keep}} fichas with history are kept and {{archive}} fichas without history are archived. No transaction is moved.',
      bulk_done: 'Batch finished: {{ok}} resolved, {{fail}} failed',
      resolved_toast: 'Group resolved: the empty ficha was archived in QuickBooks',
      merged_toast: 'Registry now points to the ficha that is kept',
      ignored_toast: 'Group marked as "not the same person"',
      ignored_note: 'Marked as different people: nothing was changed in QuickBooks nor in the registry.',
      resolved_note: 'Group already resolved: the registry points to the ficha that is kept. No transaction was moved.',
      empty: 'No groups for the current filters.',
      error_generic: 'The action could not be completed',
      error_qbo_not_connected: 'QuickBooks is not connected: nothing can be archived.',
      error_qbo_writes_frozen: 'Writes to QuickBooks are frozen (FREEZE_QBO_WRITES).',
      error_manual_merge_required: 'This case must be merged inside QuickBooks.',
      error_likely_different_group: 'These are probably two different people: no merge and no archive.',
      error_already_resolved: 'This group was already resolved.',
      error_blocked: 'Blocked: the ficha has transactions, an open balance or sits in a pending payout.',
      error_group_not_found: 'The group no longer exists (the report was refreshed).',
      error_no_groups_selected: 'No group selected.',
      error_job_already_running: 'A batch is already running.',
    },
    common: { search: 'Search', status: 'Status', date: 'Date', filter: 'Filter',
      clear: 'Clear', refresh: 'Refresh', loading: 'Loading…',
      empty: 'No results for current filters.',
      retry: 'Retry', view: 'View', back: 'Back', save: 'Save',
      cancel: 'Cancel', confirm: 'Confirm', approve: 'Approve',
      reject: 'Reject', merge: 'Merge', forward: 'Forward',
      actions: 'Actions', total: 'Total', amount: 'Amount', customer: 'Customer',
      type: 'Type', created: 'Created', updated: 'Updated',
      pagination_prev: 'Previous', pagination_next: 'Next',
      page_of: 'Page {{page}} of {{pages}}', notes: 'Notes',
      simulate: 'Simulate', export: 'Export', delete: 'Delete' },
    search: { placeholder: 'Search by order #, name, email, phone or TikTok user…',
      start_typing: 'Start typing to search across the platform',
      start_typing_hint: 'Orders · Settlements · Customers',
      group_orders: 'Orders',
      group_payouts: 'Bank payouts',
      group_deposit_refs: 'Payouts / Deposits',
      deposit_ref_in_payout: '{{label}} is in payout {{payout}}',
      group_settlements: 'Statements / Settlements',
      group_customers: 'Customers',
      not_found_title: 'Order “{{q}}” is NOT in the platform',
      not_found_subtitle: 'No matches found. If it is a recent TikTok order we can sync it now.',
      sync_from_tiktok: 'Sync now from TikTok',
      sync_done: 'Sync complete — {{pulled}} orders pulled, {{processed}} processed',
      sync_error: 'Could not sync with TikTok',
      sync_confirm_title: 'Sync manually from TikTok?',
      sync_confirm_body: 'The system ALREADY syncs automatically every 10 minutes with the safety rules (1-hour delay, buyer-data filter and cutoff date). This manual sync only pulls what is missing — it never forces Estimates the system wouldn\'t create. Continue?',
      sync_confirm_accept: 'Yes, sync',
      results_count: '{{count}} results · ↵ to open',
      open_palette: 'Open global search' },
    status: { synced: 'Synced', processed: 'Synced', pending: 'Pending',
      failed: 'Failed', cancelled: 'Cancelled', refunded: 'Refunded',
      cancelled_skipped: 'Cancelled',
      cancelled_after_sync: 'Cancelled after sync',
      manual_review: 'Review', retrying: 'Retrying',
      transfer_done: 'Transferred', open: 'Open', paid: 'Paid',
      pending_reconciliation: 'Pending reconciliation', reconciled: 'Reconciled',
      shortage: 'Shortage', overage: 'Overage',
      completed: 'Completed', waiting_label: 'Waiting for label',
      pending_review: 'Pending review', committed: 'Approved',
      reconciled_externally: 'Reconciled externally',
      deposit_deleted_in_qbo: 'Deposit deleted in QuickBooks' },
    alert_type: {
      order_cancelled_after_sync: 'Order cancelled after sync',
      aged_clearing_alert: 'Clearing balance > 7 days',
      email: 'Email',
    },
    dashboard: { title: 'Home', subtitle: 'KPIs and recent activity',
      orders_today: 'Orders today', synced: 'Synced', pending: 'Pending',
      failed: 'Failed', settlements_month: 'Monthly settlements',
      clearing_balance: 'Clearing balance',
      aged_alerts: 'Aged alerts (>7d)',
      manual_review: 'Manual review',
      activity_recent_orders: 'Recent orders',
      activity_recent_settlements: 'Recent settlements',
      activity_recent_alerts: 'Recent alerts',
      clearing_health: 'Clearing health (last 14 days)',
      simulate_orders: 'Seed demo orders',
      simulate_settlement: 'Seed demo settlement' },
    orders: { title: 'Orders', subtitle: 'Sales synced from TikTok Shop',
      filter_status: 'Status', filter_date_from: 'From', filter_date_to: 'To',
      filter_auction: 'Auction #',
      search_placeholder: 'Search by order #, name, email, phone or auction #',
      column_order: 'TikTok order', column_auction: 'Auction #', column_date: 'Date', column_customer: 'Customer',
      column_total: 'Total', column_status: 'Status',
      column_qbo: 'QBO order', column_actions: 'Actions',
      detail_title: 'Order detail', detail_so: 'Sales Order',
      detail_invoice: 'Invoice', detail_customer: 'Customer',
      invoice_number: 'Invoice #', invoice_id: 'QBO invoice ID',
      invoice_carrier: 'Carrier',
      retry: 'Retry', copy_id: 'Copy full order #', copied: 'Copied',
      export: 'Download', export_done: 'Report downloaded',
      export_error: 'Could not download the report' },
    settlements: { title: 'Settlements',
      subtitle: 'Reconcile TikTok payouts against QuickBooks',
      column_id: 'Settlement ID', column_date: 'Date',
      column_payments: 'Payments', column_fees: 'Fees',
      column_refunds: 'Refunds', column_payout: 'Expected payout',
      column_status: 'Status',
      detail_tabs_summary: 'Summary', detail_tabs_fees: 'Fees',
      detail_tabs_refunds: 'Refunds', detail_tabs_je: 'Journal Entry',
      detail_tabs_transfer: 'Transfer',
      record_transfer: 'Record bank transfer',
      search_placeholder: 'Search by Statement ID…',
      filter_from: 'From',
      filter_to: 'To',
      filter_clear: 'Clear filters',
      bank_amount: 'Bank deposit amount' },
    manual_review: { title: 'Manual review queue',
      subtitle: 'Ambiguous cases that need human decision',
      type_ambiguous_match: 'Ambiguous customer (multiple matches)',
      type_name_zip_match_diff_street: 'Same name + ZIP, different street',
      type_missing_invoice: 'Missing invoice in settlement',
      type_unmapped_sku: 'Unmapped SKU',
      type_uncategorized_charge: 'Uncategorized charge',
      type_return_processed: 'Return processed',
      type_order_sync_failed: 'Order sync failed',
      type_buyer_name_review: 'Buyer name needs review',
      type_identity_review: 'Buyer identity needs review',
      identity_order_side: 'TikTok order',
      identity_phone: 'Phone',
      identity_user_id: 'TikTok account',
      identity_address: 'Address',
      identity_transactions: 'Transactions',
      identity_active: 'Active in QBO',
      identity_inactive: 'INACTIVE in QBO',
      identity_created_separate: 'Separate customer created',
      identity_same_button: 'Same person',
      identity_distinct_button: 'Different people',
      identity_disclaimer: 'This does not change already-issued invoices and does not merge customers in QuickBooks: it only decides where the NEXT orders go. Merging in QuickBooks stays a manual decision.',
      identity_same_success: 'Link saved — the next orders will use that customer',
      identity_distinct_success: 'Confirmed as different people',
      identity_resolve_error: 'Could not resolve the identity review',
      identity_resolved_to: 'Resolved to customer',
      status_identity_same_person: 'Same person',
      status_identity_distinct: 'Different people',
      filter_status: 'Status', status_pending: 'Pending',
      status_archived: 'Archived', status_resolved: 'Resolved',
      status_all: 'All', status_approved: 'Approved',
      status_rejected: 'Rejected', status_merged: 'Merged',
      status_forwarded: 'Forwarded', status_resolved_by_retry: 'Resolved (retry)',
      status_auto_resolved: 'Auto-resolved', status_discarded: 'Discarded',
      status_resolved_already_processed: 'Already processed elsewhere',
      sort_newest: 'Newest first',
      sort_oldest: 'Oldest first',
      cleanup_button: 'Clean up pre-cutoff',
      cleanup_confirm: '{{count}} obsolete (pre-cutoff) items will be archived. This does NOT affect orders or QuickBooks, only the review queue. Continue?',
      cleanup_none: 'No obsolete items to clean up.',
      cleanup_done: 'Cleanup complete — {{count}} items archived.',
      cleanup_error: 'Could not run the cleanup.',
      target_customer: 'Merge into customer',
      retry_sync: 'Retry sync',
      retry_sync_success: 'Order re-synced with QBO',
      retry_sync_error: 'Could not retry the sync',
      buyer_name_reason_masked: "TikTok hasn't released the name yet",
      buyer_name_reason_username: 'Buyer entered their username as the name',
      buyer_name_tiktok_sent: 'Name sent by TikTok',
      buyer_name_edit_label: 'Name to use',
      buyer_data_help: 'Fill in whatever you can see in the TikTok panel. What you enter here is used for the estimate and will not be overwritten by a later TikTok update. Fields you leave empty keep whatever the order already had.',
      buyer_phone_label: 'Phone',
      buyer_phone_invalid: 'The phone must be the number (10 digits, e.g. 612 403 2250), not the name.', // Fix 60
      buyer_address1_label: 'Address',
      buyer_address2_label: 'Address (line 2)',
      buyer_city_label: 'City',
      buyer_state_label: 'State',
      buyer_zip_label: 'ZIP code',
      buyer_name_approve_button: 'Approve & create estimate',
      buyer_name_already_processed: 'TikTok had already released the data and the estimate was created automatically. No second estimate was created.',
      buyer_name_locked: 'This order is being processed right now. Refresh in a few seconds.',
      status_resolved_auto_processed: 'Created automatically',
      buyer_name_discard_button: 'Discard',
      buyer_name_approve_success: 'Estimate created successfully',
      buyer_name_approve_error: 'Could not create the estimate',
      buyer_name_discard_success: 'Case discarded',
      buyer_name_discard_error: 'Could not discard the case',
      // Fix 34 (2026-09-12): import the TikTok Seller Center order export.
      import_button: 'Import TikTok export',
      import_title: 'Import TikTok order export',
      import_help: 'Export the orders from Seller Center (Orders → Export), fill in the Recipient, Phone #, Address Line 1, Address Line 2 and City columns with what you see in the panel, and upload the file here. Orders that are still masked stay pending; the rest are loaded and their estimates are created automatically.',
      import_columns_hint: 'Accepts the original CSV or the same file saved as .xlsx. Do not rename the headers. If Excel converted the order numbers (5.77E+17), export again and fill it in without converting that column to a number.',
      import_parsing: 'Reading the file…',
      import_col_order: 'Order',
      import_col_name: 'Name',
      import_col_phone: 'Phone',
      import_col_address: 'Address',
      import_col_status: 'Result',
      import_status_ready: 'Ready to load',
      import_status_masked: 'Still masked',
      import_status_name_invalid: 'Invalid name (username or "TikTok Customer")',
      import_status_already_processed: 'Already has an estimate',
      import_status_cancelled: 'Cancelled',
      import_status_not_in_system: 'Not in the system',
      import_status_before_cutoff: 'Historical (not processed)',
      import_status_order_id_invalid: 'Invalid order number',
      import_status_order_id_damaged_by_excel: 'Order number damaged by Excel',
      import_status_order_id_empty: 'Missing order number',
      import_masked_fields: 'Missing',
      import_field_name: 'name',
      import_field_phone: 'phone',
      import_field_line1: 'address',
      import_field_city: 'city',
      import_note_phone_missing: 'No phone: loaded anyway',
      import_note_city_missing: 'No city: loaded anyway',
      import_note_updates_previous_manual_data: 'Replaces data previously entered by hand',
      import_note_waiting_status: 'Saved; the estimate is created once the order is ready to ship',
      import_note_waiting_delay: 'Saved; the estimate is created once the waiting period elapses',
      import_note_sku_mismatch: 'Auction number does not match the order: check the row',
      import_note_conflicting_rows: 'Rows of the same order with different data: the first one is used',
      import_apply_button: 'Load data and create {{count}} estimates',
      import_nothing_ready: 'No orders ready to load',
      import_cancel: 'Cancel',
      import_tracking: 'Creating estimates… {{done}} of {{total}}',
      import_done: 'Done: {{done}} estimates created, {{pending}} pending',
      import_pending_hint: 'Pending ones are processed automatically in the next cycle (every 10 minutes).',
      import_frozen: 'QuickBooks writes are frozen: the data was saved and the estimates will be created once unfrozen.',
      import_sync_error: 'The sync cycle failed; the data was saved and it retries in the next cycle',
      import_error: 'Could not process the file',
      import_close: 'Close',
      // Fix 36 (2026-09-17): auto-fill for buyers we already know.
      autofill_label: 'Auto-fill known buyers',
      autofill_help: 'When an order comes from a buyer who has ordered before and EVERYTHING matches (name initials and lengths, phone area code and last digits, street number, city, ZIP and profile name), the system fills the data and creates the estimate on its own: that order never reaches this screen. If anything does not match, or the buyer is new, the order comes through here as always.',
      prefilled_banner: 'Data filled in automatically from the previous order ({{order}}). Review and approve.',
      cannot_approve: 'Cannot approve yet — still missing:',
      autofill_on: 'Auto-fill enabled',
      autofill_off: 'Auto-fill disabled',
      autofill_error: 'Could not change the auto-fill setting',
      known_buyer_match: 'Known buyer — everything matches',
      known_buyer_partial: 'Similar buyer — needs review',
      known_buyer_previous: '{{count}} previous orders',
      known_buyer_use: 'Use this data',
      known_buyer_used: 'Data loaded into the form — review and approve',
      known_buyer_mismatch: 'Does not match',
      known_buyer_field_name: 'name',
      known_buyer_field_phone: 'phone',
      known_buyer_field_line1: 'address',
      known_buyer_field_line2: 'address line 2',
      known_buyer_field_city: 'city',
      known_buyer_field_zip: 'ZIP code',
      no_pending: 'No pending cases right now.' },
    clearing: { title: 'Clearing health',
      subtitle: 'Balance must return to 0 within 48h post-settlement',
      unreconciled: 'Unreconciled settlements',
      aged_alerts: 'Aged alerts >7 days',
      column_settlement: 'Settlement', column_age: 'Age (days)',
      column_balance: 'Balance', column_payments: 'Payments',
      column_je: 'JE', column_transferred: 'Transferred' },
    logs: { title: 'Logs and alerts', subtitle: 'Full audit trail with correlation_id',
      tab_logs: 'Logs', tab_alerts: 'Alerts',
      level: 'Level', correlation_id: 'Correlation ID' },
    config: { title: 'Configuration',
      subtitle: 'Product mappings, QBO accounts, and users',
      tab_products: 'Products (SKU → QBO Item)',
      tab_accounts: 'QBO Chart of Accounts',
      tab_adjustment_accounts: 'Adjustment accounts',
      adjustment_accounts_help: 'These are the accounts available when you create a manual adjustment or reassign a line account on a deposit. Pick an account from your QuickBooks chart of accounts to add it. Nothing is created in QuickBooks — you are only enabling an account that already exists.',
      adjustment_accounts_pick: 'Pick a QuickBooks account',
      adjustment_accounts_add: 'Add to selector',
      adjustment_accounts_name: 'Account',
      adjustment_accounts_origin: 'Source',
      adjustment_accounts_source_custom: 'Added by you',
      adjustment_accounts_source_builtin: 'Built-in',
      adjustment_accounts_missing: 'not found in QuickBooks',
      adjustment_accounts_added: 'Account added to the selector',
      adjustment_accounts_removed: 'Account removed from the selector',
      tab_users: 'Users',
      seed_accounts: 'Seed chart of accounts',
      add_user: 'Add user', new_mapping: 'New mapping' },
    health: { title: 'System health',
      subtitle: 'TikTok / QBO / MongoDB connectivity',
      mode: 'Adapter mode', env: 'Environment',
      last_settlement: 'Last settlement' },
    integrations: {
      title: 'Integrations',
      subtitle: 'Connection and data sync with TikTok Shop and QuickBooks Online',
      tiktok_subtitle: 'OAuth, catalog, orders and settlements sync',
      connected: 'Connected', not_connected: 'Not connected',
      live_ok: 'Live API OK', live_fail: 'Live API failing',
      empty_not_connected: 'TikTok Shop is not connected yet. Ask the main account owner to authorize the app.',
      connect_tiktok: 'Connect TikTok Shop',
      seller_name: 'Seller', seller_region: 'Region',
      shop_id: 'Shop ID', shop_cipher: 'Shop cipher',
      missing: 'Missing', never: 'Never',
      access_expires: 'Access token expires', refresh_expires: 'Refresh token expires',
      authorized_at: 'Authorized at', refreshed_at: 'Last refresh',
      scopes: 'Granted scopes',
      live_ping_ok: 'Live TikTok ping succeeded',
      live_ping_fail: 'TikTok rejected the ping',
      shops: 'shops',
      actions: 'Actions',
      refresh_tokens: 'Refresh tokens',
      discover_shops: 'Discover shops',
      sync_products: 'Sync products',
      sync_orders: 'Sync orders',
      sync_settlements: 'Sync settlements',
      open_partner_center: 'Open Partner Center',
      cipher_hint: 'Run "Discover shops" first to capture the shop_cipher.',
      recent_logs: 'Recent sync logs',
      no_logs: 'No sync logs yet.',
      source: 'Source', level: 'Level', message: 'Message',
      new: 'new', processed: 'processed',
      toast_refresh_ok: 'Tokens refreshed',
      toast_refresh_err: 'Error refreshing tokens',
      toast_shops_ok: 'Shops discovered',
      toast_shops_err: 'Error discovering shops',
      toast_products_ok: 'Products synced',
      toast_products_err: 'Error syncing products',
      toast_orders_ok: 'Orders synced',
      toast_orders_err: 'Error syncing orders',
      toast_settlements_ok: 'Settlements synced',
      toast_settlements_err: 'Error syncing settlements',
      // QBO
      qbo_subtitle: 'OAuth, accounting ledger and settlement reconciliation',
      qbo_card_title: 'QuickBooks Online',
      qbo_app_missing: 'QBO_CLIENT_ID and QBO_CLIENT_SECRET are missing in backend env.',
      qbo_not_connected: 'QuickBooks Online is not authorized yet. Connect a sandbox or production realm.',
      qbo_connect: 'Connect QuickBooks',
      qbo_environment: 'Environment',
      qbo_company: 'Company',
      qbo_realm: 'Realm ID',
      qbo_managed_accounts: 'Managed accounts',
      qbo_setup_chart: 'Create chart of accounts',
      qbo_disconnect: 'Disconnect',
      qbo_bootstrap_done: 'Chart of accounts ready: {{created}} created, {{skipped}} already existed',
      qbo_bootstrap_err: 'Error creating chart of accounts',
      qbo_disconnect_confirm: 'Are you sure you want to disconnect QuickBooks?',
      qbo_disconnected: 'QuickBooks disconnected',
    },
    deposits: {
      title: 'Bank deposits',
      subtitle: 'TikTok payout reconciliation → QuickBooks Bank Deposit',
      subtitle_detail: 'Payout review',
      tab_pending: 'Pending',
      tab_committed: 'Approved',
      tab_external: 'Reconciled externally',
      col_invoices: '# Invoices',
      col_balanced: 'Balanced',
      filter_from: 'From',
      filter_to: 'To',
      filter_clear: 'Clear filter',
      search_payout_placeholder: 'Search by payout ID, statement, amount, invoice # or TikTok order…',
      bank_paid_on: 'Paid to bank:',
      not_reconciled_title: 'This payout has not been reconciled yet',
      not_reconciled_subtitle: 'We could not find a deposit created for this payout yet. It may not have gone through the Bank deposits module yet.',
      col_account: 'QBO account',
      btn_review: 'Review',
      btn_reconcile_pending: 'Reconcile pending',
      reconciling: 'Reconciling…',
      btn_prepare_demo: 'Prepare demo',
      preparing_demo: 'Preparing…',
      demo_phase_backfill: 'Fetching orders…',
      demo_phase_invoicing: 'Invoicing…',
      demo_phase_refreshing: 'Refreshing…',
      demo_already_running: 'A prepare job is already running',
      demo_error: 'Error preparing the demo',
      btn_download: 'Download',
      export_include_all: 'Include all (pending + approved)',
      export_done: 'deposits exported',
      export_error: 'Error exporting deposits',
      btn_commit: 'Approve & create deposit in QBO',
      empty_pending: 'No payouts pending review.',
      empty_committed: 'No approved payouts yet.',
      empty_payments: 'No matched invoices.',
      section_payments: 'Invoices to mark as PAID',
      section_fees: 'Fees (deducted)',
      stat_gross: 'Gross sales',
      stat_fees: 'Total fees',
      stat_net: 'Net deposited',
      stat_bank: 'Bank account',
      stat_clawbacks: 'Clawbacks',
      stat_reserve: 'TikTok reserve',
      stat_adjustment: 'TikTok adjustment',
      banner_balanced: 'Balanced (diff 0)',
      banner_unbalanced: 'Not balanced — difference of',
      warning_title: 'Require manual review',
      warning_unmatched: 'Orders without invoice',
      warning_refunds: 'Refunds / clawbacks',
      warning_unmatched_blocking: 'Orders WITHOUT invoice — cannot be reconciled:',
      section_special_cases: 'Special cases',
      section_special_cases_hint: '— review before approving',
      case_clawbacks: 'Refunds / Clawbacks',
      case_reserve: 'TikTok Reserve',
      case_adjustment: 'TikTok Adjustment',
      adjustment_uncategorized: 'Uncategorized',
      case_shipping_only: 'Shipping-only (revenue 0)',
      case_unmatched: 'No invoice (unmatched)',
      net_to_bank: 'Net to bank',
      account_missing: 'Account not found in QBO',
      shipping_protection_label: 'Shipping Protection reimbursements', // Fix 62
      already_committed: 'Already approved',
      commit_disabled_hint: 'Disabled: preview is not balanced',
      confirm_title: 'Confirm deposit creation?',
      confirm_body: 'You are about to create a deposit for {{net}}, marking {{count}} invoice(s) as paid in QuickBooks. Confirm?',
      toast_committed: 'Deposit created —',
      toast_error: 'Error creating deposit in QBO',
      access_denied: 'Access restricted to admin and accountant roles.',
      verify_section_title: 'Verify against TikTok',
      verify_section_hint: 'Upload the official TikTok Excel (Seller Center → Income) to compare against what we have here',
      verify_dropzone_cta: 'Upload the TikTok Excel',
      verify_dropzone_sub: 'Drag the .xlsx file here or click to choose it',
      verify_uploading: 'Verifying…',
      verify_reverify: 'Re-verify',
      verify_match_banner: '✓ Matches TikTok',
      verify_diff_banner: 'Differences found',
      verify_toast_match: 'The TikTok Excel matches the platform',
      verify_toast_diff: 'Differences were found against the TikTok Excel',
      verify_error: 'Error verifying the Excel file',
      verify_invalid_ext: 'Upload a .xlsx file',
      verify_last_at: 'Last verification:',
      verify_col_field: 'Field',
      verify_col_platform: 'Platform',
      verify_col_diff: 'Difference',
      verify_orders_matched: 'Matching orders',
      verify_excel_rows_read: 'Excel rows read',
      verify_rows_this_statement: 'for this statement',
      verify_orders_in_excel: 'orders in Excel',
      verify_missing_in_platform: 'In TikTok but not in the platform',
      verify_missing_in_tiktok: 'In the platform but not in the TikTok Excel',
      verify_amount_mismatches: 'Different amounts',
      // Manual adjustments (Fase 5)
      why_not_balanced: 'Why doesn\'t it balance?',
      why_missing_amount: 'Missing',
      why_unmatched_orders: 'orders without invoice totaling',
      why_manual_adj_applied: 'Manual adjustments already applied',
      why_diff_total: 'Total difference',
      manual_adj_section: 'Manual adjustments',
      manual_adj_add_btn: 'Add manual adjustment',
      manual_adj_dialog_title: 'New manual adjustment',
      manual_adj_dialog_desc: 'Added to the payout reconciliation. Nothing is written to QuickBooks until you approve the deposit.',
      manual_adj_amount: 'Amount',
      manual_adj_amount_hint: 'Positive adds, negative subtracts. Pre-filled with the remaining difference.',
      manual_adj_account: 'Account',
      manual_adj_account_placeholder: 'Choose an account',
      manual_adj_note: 'Note (optional)',
      manual_adj_save: 'Save adjustment',
      manual_adj_saving: 'Saving…',
      manual_adj_deleted: 'Adjustment deleted',
      manual_adj_added: 'Manual adjustment added',
      manual_adj_error: 'Error saving the adjustment',
      manual_adj_delete_error: 'Error deleting the adjustment',
      manual_adj_empty: 'No manual adjustments yet.',
      manual_adj_by: 'by',
      manual_adj_readonly_hint: 'Deposit already approved — adjustments are now read-only.',
      manual_adj_readonly_hint_external: 'Payout reconciled externally — adjustments are now read-only.',
      line_account_change: 'Change account',
      line_account_reassign_title: 'Reassign account',
      line_account_error: 'Error reassigning the account',
      line_account_updated: 'Account reassigned',
      account_eligible_missing: 'not found in QBO',
      account_reassign_help: 'Use the "Change account" button on any line to reassign it to another eligible deposit account.',
      // Split an adjustment line across multiple accounts (Fix 31)
      line_split_btn: 'Split',
      line_split_remove_btn: 'Remove split',
      line_split_title: 'Split adjustment line',
      line_split_desc: 'Distribute this amount across several QuickBooks accounts',
      line_split_pick_account: 'Choose an account',
      line_split_note_placeholder: 'Note (optional)',
      line_split_add_part: 'Add part',
      line_split_remaining: 'Remaining',
      line_split_save: 'Save split',
      line_split_saved: 'Line split',
      line_split_removed: 'Split removed',
      line_split_error: 'Error saving the split',
      line_split_mismatch: "The parts' sum ({{parts}}) doesn't match the line amount ({{line}}) — nothing was saved.",
      line_split_invalid: 'The split no longer matches the amount — showing the full line',
      line_split_part_label: 'part {{n}}/{{total}}',
      // Reconciled externally (Fase 8)
      empty_external: 'No payouts marked as reconciled externally.',
      btn_mark_reconciled: 'Already reconciled in QuickBooks',
      mark_reconciled_dialog_title: 'Mark as reconciled externally?',
      mark_reconciled_dialog_desc: 'This does NOT create anything in QuickBooks. It only marks this payout as already reconciled by you so it stops showing up in Pending.',
      mark_reconciled_note: 'Note (optional)',
      mark_reconciled_qbo_id: 'QBO deposit number (optional)',
      mark_reconciled_qbo_id_placeholder: 'E.g. 4521',
      mark_reconciled_confirm: 'Yes, mark as reconciled',
      mark_reconciled_success: 'Payout marked as reconciled externally',
      mark_reconciled_error: 'Error marking the payout',
      externally_reconciled_banner: 'Reconciled externally',
      externally_reconciled_by: 'by',
      externally_reconciled_linked: 'Linked QBO deposit',
      unmark_reconciled_btn: 'Undo',
      unmark_reconciled_confirm_title: 'Undo the reconciled mark?',
      unmark_reconciled_confirm_desc: 'The payout goes back to Pending. This does not affect anything in QuickBooks.',
      unmark_reconciled_success: 'Mark reverted — the payout is back in Pending',
      unmark_reconciled_error: 'Error reverting the mark',
      bulk_mark_btn: 'Mark old as reconciled…',
      bulk_mark_title: 'Mark old payouts as reconciled',
      bulk_mark_dialog_desc: 'This does NOT create anything in QuickBooks. It only marks these payouts as already reconciled so they no longer show under Pending.',
      bulk_mark_before_label: 'Mark all payouts before:',
      bulk_mark_count_suffix: 'pending payouts match the criteria',
      bulk_mark_none: 'No pending payouts match the criteria.',
      bulk_mark_note_default: 'Manually reconciled in QB before the integration',
      bulk_mark_confirm_prefix: 'Yes, mark',
      bulk_mark_confirm_suffix: 'payouts',
      bulk_mark_selected_btn: 'Mark selected as reconciled',
      bulk_mark_success_suffix: 'marked',
      bulk_mark_error: 'Bulk mark failed',
      commit_disabled_external_hint: 'Disabled: this payout is already reconciled externally',
      // Anti-duplicate (Fase 8)
      duplicate_dialog_title: 'Possible duplicate deposit in QBO',
      duplicate_dialog_desc: 'We found deposit(s) in QuickBooks with a similar date or amount to this payout. Review before continuing:',
      duplicate_col_id: 'QBO ID',
      duplicate_col_date: 'Date',
      duplicate_col_amount: 'Amount',
      duplicate_col_note: 'Note',
      duplicate_link_btn: 'It\'s this one → link',
      duplicate_force_btn: 'Not the same → create anyway',
      duplicate_link_success: 'Payout linked to the existing deposit',
      duplicate_link_error: 'Error linking the deposit',
      // Bank-payout grouped view (by payment_id)
      view_statements: 'Statements',
      view_payouts: 'Bank payouts',
      view_payouts_hint: 'Grouped by bank payout — each group total is the exact amount credited to the bank',
      col_payment_id: 'Bank payout (payment ID)',
      col_statements: '# Statements',
      col_total_bank: 'Total to bank',
      no_payment_id: 'No TikTok payment ID',
      group_empty: 'No bank payouts to show.',
      group_expand: 'View statements',
      group_commit_btn: 'Approve full payout',
      group_recommit_btn: 'Re-approve (create the deposit again)',
      deposit_deleted_message: 'This payout\'s deposit was deleted in QuickBooks. You can re-approve it to create it again.',
      group_commit_title: 'Approve the whole bank payout?',
      group_commit_desc: 'A SINGLE Bank Deposit will be created in QuickBooks for the payout total, combining the lines of all its statements — so the QBO Match is 1:1 with the bank line.',
      group_commit_date_label: 'Deposit date (day the money hit the bank)',
      group_commit_date_hint_known: 'Default: payout date reported by TikTok.',
      group_commit_date_hint_unknown: 'TikTok did not report the payout date — default: newest statement. Adjust it against the bank statement.',
      group_commit_confirm: 'Yes, create the deposit',
      group_commit_success: 'Payout approved — deposit created',
      payments_recreated_toast: 'payment(s) had been manually deleted in QuickBooks and were recreated automatically',
      group_commit_progress: 'Progress',
      link_invoice_btn: 'Assign invoice',
      link_invoice_title: 'Assign an existing invoice',
      link_invoice_desc: 'Enter the invoice number (DocNumber) you see in QuickBooks for this order. It is validated against QuickBooks before linking.',
      link_invoice_placeholder: 'e.g. 8440',
      link_invoice_confirm: 'Link invoice',
      link_invoice_success: 'Invoice linked',
      link_invoice_order_amount: 'Order amount',
      link_invoice_reason: 'Reason',
      link_invoice_reason_no_estimate: 'no estimate in system',
      link_invoice_reason_no_invoice: 'estimate without linked invoice',
      // Fix 64 (2026-10-26)
      change_invoice_btn: 'Change invoice',
      link_invoice_reason_change: 'change invoice {{doc}} ({{n}} order(s) in this line)',
      link_invoice_amount_mismatch: 'Invoice {{doc}} is for {{invoice}} and the order is for {{order}} — you can link it anyway',
      link_invoice_error: 'Could not link the invoice',
      group_commit_error: 'Error approving the full payout',
      group_blocked_title: 'The full payout cannot be approved yet',
      group_blocked_hint: 'Resolve these statements first (or approve them individually):',
      blocked_payments_title: 'Payments already included in another QuickBooks deposit',
      blocked_payments_desc: 'These payments were already consumed by ANOTHER Bank Deposit in QuickBooks and cannot be used again. The recommended path is to resolve or undo that old deposit in QuickBooks before retrying.',
      blocked_payments_col_invoice: 'Invoice',
      blocked_payments_col_customer: 'Customer',
      blocked_payments_col_amount: 'Amount',
      blocked_payments_col_deposit: 'Deposit that contains it',
      blocked_payments_unknown_deposit: 'Already applied to another deposit (could not identify which one)',
      blocked_payments_payout_total: 'Payout total',
      blocked_payments_excluded_total: 'Excluded amount',
      blocked_payments_result_total: 'Deposit total to create',
      blocked_payments_warning: 'This deposit will NOT match the bank line due to the excluded difference.',
      blocked_payments_exclude_btn: 'Exclude and create with the rest',
      blocked_payments_close_btn: 'Close and resolve in QuickBooks',
      blocked_payments_exclude_success: 'Deposit created excluding the blocked payments',
      blocked_payments_exclude_error: 'Error creating the deposit excluding blocked payments',
      group_mark_btn: 'Mark whole payout as already reconciled',
      group_mark_title: 'Mark the whole payout as reconciled in QuickBooks?',
      group_mark_desc: 'This does NOT create anything in QuickBooks. It marks every pending statement of this payout as already reconciled by you.',
      group_mark_confirm: 'Yes, mark the payout',
      group_mark_success: 'payout statements marked',
      group_mark_error: 'Error marking the payout',
      blocker_not_balanced: 'does not balance',
      blocker_sum_mismatch: 'the statements do not add up to the bank payment amount',
      blocker_statement_missing: 'this statement has no deposit generated yet (see below)',
      group_sum_mismatch: 'statements sum {{sum}} · diff {{diff}}',
      group_adj_add: 'Add payout adjustment',
      group_adj_title: 'Bank payout adjustment',
      group_adj_desc: 'Covers the difference between what the statements add up to and the amount credited to the bank. It does not change any statement balance: it is added as one more deposit line on approval.',
      group_adj_bank: 'Amount credited to bank',
      group_adj_statements: 'Statements sum',
      group_adj_missing: 'Missing to balance',
      group_adj_amount: 'Adjustment amount',
      group_adj_account: 'Account',
      group_adj_note: 'Note (optional)',
      group_adj_added: 'Adjustment added to the payout',
      group_adj_removed: 'Adjustment removed',
      group_source_statement: 'not confirmed by the TikTok payments API',
      blocker_already_committed: 'already approved',
      blocker_reconciled_externally: 'reconciled externally',
      blocker_not_pending: 'not pending',
      part_of_payout: 'This statement is part of bank payout {{id}} for {{amount}}, together with {{n}} more.',
      part_of_payout_single: 'This statement is the only one in bank payout {{id}} for {{amount}}.',
      view_group_btn: 'View the full payout',
      aggregate_mode_title: 'No order detail available (TikTok no longer exposes the transactions of this statement).',
      aggregate_mode_desc: 'Aggregate deposit: it does NOT mark invoices as paid. It books the total sales, the fees to their accounts and the net to the bank.',
      adjustment_only_title: 'TikTok adjustment (no orders attached) — typically an Early Settlement advance or recovery',
      adjustment_only_desc: 'The full amount goes to the adjustment account (reassignable) and the net to the bank. There are no invoices to mark as paid.',
      adjustment_only_badge: 'Adjustment (no orders)',
      backfill_started: 'Backfill started in background',
      backfill_pulling: 'Pulling statements from TikTok…',
      backfill_empty_ranges: 'TikTok returned no statements for:',
      backfill_payments: '{{n}} bank payments pulled from TikTok',
      backfill_payments_empty: 'TikTok returned no payments for the range — check Logs → tiktok.payments_pull.raw',
      backfill_running: 'Reconciling {{done}}/{{total}}…',
      backfill_done: 'Backfill finished — {{reconciled}} reconciled ({{balanced}} balanced / {{unbalanced}} not)',
      backfill_error: 'The backfill finished with an error',
      backfill_already_running: 'A backfill is already running',
      reviewed_badge: 'Reviewed ✓',
      mark_reviewed: 'Mark as reviewed',
      unmark_reviewed: 'Unmark reviewed',
      review_marked: 'Statement marked as reviewed',
      review_unmarked: 'Reviewed mark removed',
      review_error: 'Could not change the reviewed mark',
      reviewed_progress: '{{done}}/{{total}} reviewed',
      reviewed_meta: 'Reviewed by {{by}} · {{at}}',
      missing_statements_title: 'Statements of this payout with no deposit yet:',
      not_processed_yet: 'Not processed yet — no TikTok detail available',
      statement_not_downloaded: 'Not in the system yet — run "Reconcile pending"',
      generate_aggregate_btn: 'Generate aggregate deposit',
      generate_aggregate_hint: 'Uses the statement totals (no invoice list). Nothing is written to QuickBooks.',
      generate_aggregate_success: 'Aggregate deposit generated for statement {{id}}',
      generate_aggregate_error: 'Could not generate the aggregate deposit',
      statement_attempts: '{{n}} attempts with no transactions',
      unprocessed_search_title: 'Statements found with no deposit generated',
      find_by_title: 'Matches inside payouts',
      find_by_hint: 'Invoices and orders included INSIDE these payouts (in addition to the list results).',
      find_by_invoice: 'Invoice {{n}}',
      find_by_order: 'Order {{n}}',
      find_by_bank_group: 'bank group {{n}}',
      find_by_kind_invoice: 'invoice paid',
      find_by_kind_order: 'invoiced order',
      find_by_kind_clawback: 'clawback / return',
      find_by_kind_shipping_only: 'shipping only',
      find_by_kind_unmatched: 'no invoice matched',
      unprocessed_search_hint: 'They exist in the system but TikTok returned no detail, so they do not show up as payouts.',
    },
  },
};

const LanguageContext = createContext({ lang: 'es', setLang: () => {}, t: () => '' });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem('lovi_lang') || 'es'
  );
  const value = useMemo(() => {
    const dict = translations[lang] || translations.es;
    const t = (path) => {
      const parts = String(path).split('.');
      let cur = dict;
      for (const p of parts) {
        if (cur == null) return path;
        cur = cur[p];
      }
      return cur == null ? path : cur;
    };
    return {
      lang,
      setLang: (l) => { localStorage.setItem('lovi_lang', l); setLang(l); },
      t,
    };
  }, [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
